export const conversationStep = [
  {
    target: "#conversationlist",
    content:
      "View all your conversation threads in this list. Tap on any conversation to resume chat seamlessly.",
    disableBeacon: true,
  },
  {
    target: '[data-testid="MoreVertIcon"]',
    content:
      "Click the three dots menu to access conversation options like  edit and delete.",
    disableBeacon: true,
  },
];

export const noConversation = {
  target: "#noconversation",
  content:
    "No conversations created yet. Click on new conversation button to create new conversation.",
  disableBeacon: true,
};

export const settingButton = {
  target: "#settingsbutton",
  content:
    "Click the Settings button to adjust temperature, manage top-ranked pages, refer chat history and delete all conversation.",
  disableBeacon: true,
};

export const chatSectionStep = [
  {
    target: "#outlined-multiline-flexible",
    content: "Provide the content to the text field to interact with the model",
    disableBeacon: true,
  },
  {
    target: "#micicon",
    content:
      "Ask the question by speaking into the microphone to interact with the model",
    disableBeacon: true,
  },
];

export const webSteps = [
  {
    target: "#list-item-0",
    content: "Click on Web to get real-time information.",
    disableBeacon: true,
  },
  {
    target: "#pi",
    content:
      "Toggle 'Enable PII Redaction' to prevent sending personal information.",
    disableBeacon: true,
  },
];

export const vanillaVMSteps = [
  {
    target: "#list-item-1",
    content: "Click on GPT for general question-answering",
    disableBeacon: true,
  },
  {
    target: "#pi",
    content:
      "Toggle 'Enable PII Redaction' to prevent sending personal information.",
    disableBeacon: true,
  },
];

export const userFormatSteps = [
  {
    target: "#prompt",
    content:
      "Click the add icon to enter a prompt value and interact with the model.",
    disableBeacon: true,
  },
  {
    target: "#promptcheckbox",
    content:
      "Click the checkbox to select the prompt and ask the corresponding question. The answer will be provided based on the data in the prompt.",
    disableBeacon: true,
  },
  {
    target: "#editicon",
    content: "Click the edit icon to modify the prompt value.",
    disableBeacon: true,
  },
  {
    target: "#deleteicon",
    content: "Click the delete icon to remove the prompt value.",
    disableBeacon: true,
  },
];

export const userFormatElseStep = {
  target: "#prompt",
  content:
    "Click the add icon to enter a prompt value and interact with the model.",
  disableBeacon: true,
};

export const promptsStep = [
  {
    target: "#saved",
    content: "Saved queries from the chats.",
    disableBeacon: true,
  },
  {
    target: "#copyicon",
    content: "Click on the copy icon to copy the saved query.",
    disableBeacon: true,
  },
  {
    target: "#savedediticon",
    content: "Click the edit icon to modify the saved query.",
    disableBeacon: true,
  },
  {
    target: "#saveddeleteicon",
    content: "Click the delete icon to remove the saved query.",
    disableBeacon: true,
  },
];

export const promptElseStep = {
  target: "#saved",
  content: "Saved queries from the chats.",
  disableBeacon: true,
};

export const docsSteps = [
  {
    target: "#list-item-2",
    content:
      "Click on DOCS to extract information from PDF, text, and DOC files, or to upload files.",
    disableBeacon: true,
  },
  {
    target: "#top",
    content:
      "Toggle between the top 3 ranked pages to get answers based on the top 3 results.",
    disableBeacon: true,
  },
  {
    target: "#pi",
    content:
      "Toggle 'Enable PII Redaction' to prevent sending personal information.",
    disableBeacon: true,
  },
];

export const fileActionSteps = [
  {
    target: "#filechecked",
    content:
      "Click the checkbox to select the file and ask the corresponding question. The answer will be provided based on the data in the file.",
    disableBeacon: true,
  },
  {
    target: "#deletefile",
    content: "Click the delete icon to remove the file.",
    disableBeacon: true,
  },
  {
    target: "#shareicon",
    content:
      "Click the share icon to share the file with other users by entering their email ID.",
    disableBeacon: true,
  },
  {
    target: "#infoicon",
    content:
      "Click the info icon to view the list of users who have access to the shared file.",
    disableBeacon: true,
  },
];

export const filesSteps = [
  {
    target: "#uploadfileicon",
    content:
      "Click on add icon to upload or view PDF, text, and DOC files to interact with the model.",
    disableBeacon: true,
  },
  ...fileActionSteps,
];

export const noFilesSteps = {
  target: "#uploadfile",
  content:
    "Click the add icon to upload or view PDF, text, and DOC files to interact with the model.",
  disableBeacon: true,
};

export const sharedFilesSteps = [
  {
    target: "#shareddoc",
    content: "Documents shared by you or other users.",
    disableBeacon: true,
  },
  {
    target: "#copresenticon",
    content: "Click the icon to view who has shared the file with the user.",
    disableBeacon: true,
  },
  {
    target: "#deleteshared",
    content: "Click the delete icon to remove the shared file.",
    disableBeacon: true,
  },
];

export const noSharedFilesSteps = {
  target: "#shareddoc",
  content: "List of the documents shared by other users.",
  disableBeacon: true,
};

export const imageSteps = [
  {
    target: "#list-item-3",
    content:
      "Click on Image to extract information from images in PNG, JPG, or JPEG formats, or to upload an image.",
    disableBeacon: true,
  },
];

export const imageFileSteps = [
  {
    target: "#uploadfileicon",
    content:
      "Click the add icon to upload an image in the allowed formats: PNG, JPG, or JPEG.",
    disableBeacon: true,
  },
  {
    target: "#filechecked",
    content:
      "Click the checkbox to select the image and ask the corresponding question. The answer will be provided based on the uploaded image.",
    disableBeacon: true,
  },
  {
    target: "#clickonimage",
    content: "Click on the text to view the image.",
    disableBeacon: true,
  },
  {
    target: "#deletefile",
    content: "Click the delete icon to remove the uploaded image.",
    disableBeacon: true,
  },
  {
    target: "#shareicon",
    content:
      "Click the share icon to share the image with other users by entering their email ID.",
    disableBeacon: true,
  },
  {
    target: "#infoicon",
    content:
      "Click the info icon to view the list of users who have access to the shared image.",
    disableBeacon: true,
  },
];

export const imageElseSteps = {
  target: "#uploadfile",
  content:
    "Click the Upload file button to upload an image in the allowed formats: PNG, JPG, or JPEG.",
  disableBeacon: true,
};

export const collectionSteps = [
  {
    target: "#list-item-4",
    content:
      "Click on Collection to upload the combination of PDF and Image files.",
    disableBeacon: true,
  },
  {
    target: "#uploadfileicon",
    content: "Click the add icon to create a new collection.",
    disableBeacon: true,
  },
  {
    target: "#collectioncheckbox",
    content:
      "Click the checkbox to select the collection, then ask the corresponding question. The answer will be provided based on the data in the selected collection.",
    disableBeacon: true,
  },
  {
    target: "#editcollection",
    content:
      "Click the edit icon to upload the files and images to the collection.",
    disableBeacon: true,
  },
  {
    target: "#deletecollectionicon",
    content: "Click the delete icon to remove the collection.",
    disableBeacon: true,
  },
  {
    target: "#shareicon",
    content:
      "Click the share icon to share the collection with other users by entering their email ID.",
    disableBeacon: true,
  },
  {
    target: "#infoicon",
    content:
      "Click the info icon to view the list of users who have access to the shared collection.",
    disableBeacon: true,
  },
];

export const imageGenerationSteps = [
  {
    target: "#list-item-5",
    content:
      "Click on Image Generation to create images from text descriptions.",
    disableBeacon: true,
  },
  {
    target: "#generateimage",
    content:
      "Click the generate button to create your image based on the text prompt.",
    disableBeacon: true,
  },
  {
    target: "#downloadimage",
    content:
      "Click the download icon to save the generated image to your device.",
    disableBeacon: true,
  },
];

export const allTypeSteps = [
  {
    target: "#list-item-0",
    content: "Click on Web to get real-time information.",
    disableBeacon: true,
  },
  {
    target: "#list-item-1",
    content: "Click on GPT for general question-answering",
    disableBeacon: true,
  },
  {
    target: "#list-item-2",
    content:
      "Click on DOCS to extract information from PDF, text, and DOC files, or to upload files.",
    disableBeacon: true,
  },
  {
    target: "#list-item-3",
    content:
      "Click on Image to extract information from images in PNG, JPG, or JPEG formats, or to upload an image.",
    disableBeacon: true,
  },
  {
    target: "#list-item-4",
    content:
      "Click on Collection to upload the combination of PDF and Image files.",
    disableBeacon: true,
  },
  // {
  //   target: "#list-item-4",
  //   content:
  //     "Click on Image Generation to create images from text descriptions.",
  //   disableBeacon: true,
  // },
  {
    target: "#logout",
    content: "Click on the logout icon to exit the screen and log out.",
    disableBeacon: true,
  },
];

export const styles = {
  tooltip: {
    fontSize: "14px",
  },
  tooltipContent: {
    padding: "0px",
  },
  options: { zIndex: 15000 },
  buttonNext: { backgroundColor: "#F8991C", color: "#fff" },
  buttonBack: {
    backgroundColor: "transparent",
    color: "#F8991C",
    border: "1px solid #F8991C",
  },
  buttonSkip: { color: "#F8991C" },
};

export const usernameStep = {
  target: "#username",
  content: "This displays your current logged-in account name.",
  disableBeacon: true,
};

export const locale = {
  skip: "Close",
  next: "Next",
  back: "Back",
  last: "Finish",
};
